// src/components/common/KanbanCard.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './KanbanCard.css';

interface KanbanCardProps<T> {
  item: T;
  renderContent: (item: T) => React.ReactNode;
  isDraggable?: boolean;
  onDragStart?: (item: T) => void;
  actionButton?: {
    icon: IconDefinition;
    onClick: (item: T) => void;
    title: string;
    className?: string; // Para estilização específica do botão
  };
  isValid?: boolean; // Para estilização condicional (ex.: valido em Requisicoes)
  className?: string; // Classes adicionais
}

const KanbanCard = <T,>({
  item,
  renderContent,
  isDraggable = false,
  onDragStart,
  actionButton,
  isValid = true,
  className = '',
}: KanbanCardProps<T>) => {
  const handleDragStart = (_e: React.DragEvent<HTMLDivElement>) => {
    if (isDraggable && onDragStart) {
      onDragStart(item);
    }
  };

  return (
    <div
      className={`kanban-card ${isValid ? '' : 'invalid-card'} ${className}`}
      draggable={isDraggable}
      onDragStart={handleDragStart}
    >
      <div className="kanban-card-content">{renderContent(item)}</div>
      {actionButton && (
        <button
          className={`action-button ${actionButton.className || ''}`}
          onClick={() => actionButton.onClick(item)}
          title={actionButton.title}
        >
          <FontAwesomeIcon icon={actionButton.icon} />
        </button>
      )}
    </div>
  );
};

export default KanbanCard;
